import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp0056',
    ecrans: ['00-2']
});

